import { enqueueSnackbar } from 'notistack';
import type React from 'react';
import type { RequiredTargetingSectionKeysType } from '../context/types.ts';
import type { TargetingPresetOptionProps } from '../utils/types.ts';

export const useSubOptionCheckbox = (
  subOptions: TargetingPresetOptionProps[],
  sectionKey: RequiredTargetingSectionKeysType,
  elementIndex: number
) => {
  const subSelectedCount = subOptions.filter(option => option.isSelected).length;
  const allSelected = subSelectedCount === subOptions.length && subOptions.length > 0;
  const someSelected = subSelectedCount > 0 && !allSelected;

  const handleCheckboxClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    const castedEvent = event as React.MouseEvent<HTMLButtonElement>;

    try {
      if (someSelected || allSelected) {
        subOptions.forEach((option, index) => {
          if (option.isSelected) {
            option.onClick?.(castedEvent, sectionKey, elementIndex, index);
          }
        });
      } else {
        subOptions.forEach((option, index) => {
          if (!option.isSelected) {
            option.onClick?.(castedEvent, sectionKey, elementIndex, index);
          }
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
      throw new Error(error.message);
    }
  };

  return {
    subSelectedCount,
    customCheckbox: {
      checked: allSelected,
      indeterminate: someSelected,
      onClick: handleCheckboxClick,
    },
  };
};
